import React, { useState, useEffect } from "react";
import ReportDisplay from "./ReportDisplay";

const STATUS_CONFIG = {
  pending: { modifier: "pending", label: "Pending", icon: "○" },
  stage1_in_progress: { modifier: "in-progress", label: "Stage 1", icon: "◐" },
  stage2_in_progress: { modifier: "in-progress", label: "Stage 2", icon: "◑" },
  stage3_in_progress: { modifier: "in-progress", label: "Stage 3", icon: "◕" },
  stage4_in_progress: { modifier: "in-progress", label: "Stage 4", icon: "◕" },
  completed: { modifier: "completed", label: "Completed", icon: "●" },
  failed: { modifier: "failed", label: "Failed", icon: "✕" },
};

const ReportsList = ({ isOpen, onClose, isAdmin = false }) => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedReportId, setSelectedReportId] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setLoading(true);
      fetch("/api/google_ads_ai/reports", { headers: { Accept: "application/json" } })
        .then((res) => res.ok ? res.json() : { reports: [] })
        .then((data) => { setReports(data.reports || []); setLoading(false); })
        .catch(() => setLoading(false));
    }
  }, [isOpen]);

  const getStatusConfig = (status) => STATUS_CONFIG[status] || STATUS_CONFIG.pending;

  if (!isOpen) return null;

  return (
    <div className="reports-list-modal-overlay" onClick={onClose}>
      <div
        className={`reports-list-modal-container ${selectedReportId ? "reports-list-modal-container--with-detail" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="reports-list-modal__header">
          <div className="reports-list-modal__title-row">
            <h2 className="reports-list-modal__title">{selectedReportId ? "Report Details" : "Google Ads Reports"}</h2>
          </div>
          <button type="button" onClick={onClose} className="reports-list-modal__close-btn">×</button>
        </div>
        <div className="reports-list-modal__content">
          {selectedReportId ? (
            <ReportDisplay reportId={selectedReportId} onClose={() => setSelectedReportId(null)} isAdmin={isAdmin} />
          ) : loading ? (
            <div className="reports-list-modal__loading">Loading reports...</div>
          ) : reports.length === 0 ? (
            <div className="reports-list-modal__empty">
              <p className="reports-list-modal__empty-title">No reports yet</p>
              <p className="reports-list-modal__empty-sub">Generate your first AI campaign to see reports here.</p>
            </div>
          ) : (
            <div className="reports-list-modal__list">
              {reports.map((report) => {
                const statusConfig = getStatusConfig(report.status);
                return (
                  <div
                    key={report.id}
                    className="reports-list-item"
                    onClick={() => setSelectedReportId(report.id)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => e.key === "Enter" && setSelectedReportId(report.id)}
                  >
                    <div className="reports-list-item__row">
                      <div>
                        <h4 className="reports-list-item__title">{report.event_name || "Unknown Event"}</h4>
                        <p className="reports-list-item__date">{new Date(report.created_at).toLocaleString()}</p>
                      </div>
                      <div className="reports-list-item__status-group">
                        <span className={`reports-list-item__badge reports-list-item__badge--${statusConfig.modifier}`}>
                          <span>{statusConfig.icon}</span> {statusConfig.label}
                        </span>
                      </div>
                    </div>
                    {report.error_message && (
                      <p className="reports-list-item__error">{report.error_message.substring(0, 100)}...</p>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReportsList;
